import { render, staticRenderFns } from "./OctButton.vue?vue&type=template&id=9ca4fff4&scoped=true&"
import script from "./OctButton.vue?vue&type=script&lang=js&"
export * from "./OctButton.vue?vue&type=script&lang=js&"
import style0 from "./OctButton.vue?vue&type=style&index=0&id=9ca4fff4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca4fff4",
  null
  
)

export default component.exports